export default "__VITE_ASSET__22a3d337__"